import { createStateReducer } from 'hooks/useSateReduxed';
import { reducers } from 'features/pay/constants';
const remindedRequest = createStateReducer(reducers.REMINDED_REQUEST);
export default remindedRequest;
